import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
Vue.use(Vuex);
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import '@/assets/styles/style.css' // 全局css样式
import Vue2OrgTree from 'vue2-org-tree';
Vue.use(Vue2OrgTree);
import './assets/styles/org-tree.less';


Vue.config.productionTip = false


// 时间转换 YYYY/MM/DD HH:mm
import {
    time_hm,
    time_hms
} from "./assets/tool/custom_time";
// return ''
Vue.prototype.time_hm = time_hm;
// return '-'
Vue.prototype.time_hms = time_hms;

import {
    number_format,
    number_format2
} from "./assets/tool/number_format";
// 数字 1,000.00
Vue.prototype.number_format = number_format;
// 数字 1,000
Vue.prototype.number_format2 = number_format2;

import authjson from './utils/authjson'; // 权限方法
Vue.prototype.authjson = authjson;


Vue.config.productionTip = false
// store.dispatch('login/RouterAuth') //路由记录name

// 版本号的判断逻辑，版本号不一致就重新加载
const VUE_APP_VERSION = require('../package.json').version;
const vers = window.localStorage.getItem("Version");
if (VUE_APP_VERSION != vers) {
    localStorage.clear();
    sessionStorage.clear();
    window.localStorage.setItem("Version", VUE_APP_VERSION);
    location.reload();
}

// 过滤空格
Vue.directive('trim', {
    bind(el) {
        const input = el.querySelector('input');

        if (input) {
            let isComposing = false; // 标记是否处于输入法预编辑状态

            // 处理 compositionstart 事件
            input.addEventListener('compositionstart', () => {
                isComposing = true;
            });

            // 处理 compositionend 事件
            input.addEventListener('compositionend', (event) => {
                isComposing = false;
                // 去除首尾空格并手动触发 input 事件
                const newValue = event.target.value.trim();
                if (event.target.value !== newValue) {
                    event.target.value = newValue;
                    const evt = new Event('input', {
                        bubbles: true
                    });
                    input.dispatchEvent(evt);
                }
            });

            // 处理 input 事件，过滤首尾空格
            input.addEventListener('input', (event) => {
                // 在未处于预编辑状态时处理输入
                if (!isComposing) {
                    const newValue = event.target.value.trim();
                    if (event.target.value !== newValue) {
                        event.target.value = newValue;
                        const evt = new Event('input', {
                            bubbles: true
                        });
                        input.dispatchEvent(evt);
                    }
                }
            });
        }
    }
});


let lang = sessionStorage.getItem('language');
if (!lang) {
    sessionStorage.setItem('language', 'en')
}
import i18n from './assets/i18n/i18n';




new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')